import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/PageHeader';
import { InstanceList } from '@/components/InstanceList';
import { InstanceFormDialog } from '@/components/InstanceFormDialog';
import { api } from '@/lib/api';
import { useAdaptivePolledData } from '@/lib/hooks/useAdaptivePolledData';
import type { Instance } from '@/types/instance';

const fetchInstances = () => api.instances.list();

export function InstancesPage() {
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState<Instance | null>(null);
  const { data, error, loading, refetch } = useAdaptivePolledData(
    fetchInstances,
    (list) => (list?.some((i) => i.last_sync_status === 'in_progress') ? 5_000 : 30_000),
    30_000,
  );

  const openCreate = () => {
    setEditing(null);
    setFormOpen(true);
  };
  const openEdit = (i: Instance) => {
    setEditing(i);
    setFormOpen(true);
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Instances"
        description="Portainer instances the Bridge syncs from."
        actions={
          <Button onClick={openCreate}>
            <Plus aria-hidden="true" />
            Add instance
          </Button>
        }
      />
      <InstanceList
        instances={data}
        error={error}
        loading={loading}
        refetch={refetch}
        onAdd={openCreate}
        onEdit={openEdit}
      />
      <InstanceFormDialog open={formOpen} onOpenChange={setFormOpen} instance={editing} onSaved={refetch} />
    </div>
  );
}
